import { ContentObject } from '../../base';
import { createScores } from '../../base/scoreHelper';

export const uberGenieCaseStudy: ContentObject = {
    id: 'uber-genie-copilot',
    kind: 'system',
    type: 'case-study',
    name: "Genie: Uber's Gen AI On-Call Copilot",
    description:
        "Uber's Genie demonstrates how leveraging generative AI via a sophisticated RAG application can transform the way on-call operations are managed. By streamlining the retrieval of internal documentation and automating responses to common queries, Genie not only reduces operational delays but also significantly increases the productivity of software developers and support engineers. With robust technical underpinnings, measurable successes, and integrated feedback loops, Genie is poised to further redefine on-call support dynamics within modern tech environments.",
    url: 'https://www.uber.com/blog/genie-ubers-gen-ai-on-call-copilot/',
    scores: createScores({
        detailedMetrics: 10,
        relevanceToUseCase: 5,
        reliabilityOfSource: 10,
        strategicAndTacticalInformation: 10,
        technicalImplementationDetails: 10,
        noVendorBias: 10,
        relevanceToClient: 5,
    }),
    publishedAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
    markdown: `
# Genie: Uber's Gen AI On-Call Copilot

Uber's Genie project represents a significant advancement in the application of generative AI for developer operations, specifically targeting the challenges of on-call support. This case study explores how Uber has successfully implemented an AI copilot that understands and processes internal documentation to streamline incident response and enhance developer productivity.

## Implementation Details

The Genie system leverages a sophisticated RAG (Retrieval Augmented Generation) architecture to provide real-time assistance during incident response. Key technical components include:

- Advanced document retrieval and contextualization
- Integration with existing incident management tools
- Real-time query processing and response generation
- Continuous learning from user interactions
- Secure access to internal documentation

## Results and Impact

The implementation has yielded significant improvements in on-call operations:

- Reduced mean time to resolution for incidents
- Enhanced developer experience during on-call rotations
- More efficient access to relevant documentation
- Decreased cognitive load during high-stress situations
- Improved knowledge retention and transfer

## Technical Architecture

The system architecture includes:

1. Document Processing Pipeline
   - Automated ingestion of internal documentation
   - Semantic indexing and vector storage
   - Real-time document updates

2. Query Processing System
   - Natural language understanding
   - Context-aware response generation
   - Integration with existing tools

3. Feedback Loop
   - User interaction tracking
   - Continuous model improvement
   - Quality assurance mechanisms

## Future Developments

Uber plans to expand Genie's capabilities with:

- Enhanced multi-modal support
- Deeper integration with development workflows
- Advanced analytics and insights
- Expanded knowledge base coverage

This case study demonstrates how generative AI can be effectively applied to enhance developer productivity while maintaining high standards of reliability and accuracy in critical operations.
    `,
    references: [
        {
            id: '1',
            name: "Genie: Uber's Gen AI On-Call Copilot",
            author: 'Uber Engineering',
            year: '2024',
            publisher: 'Uber Engineering Blog',
            url: 'https://www.uber.com/blog/genie-ubers-gen-ai-on-call-copilot/',
        },
    ],
};
